import { css } from "styled-components";
import { FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
const veciCalendarInputStyles = {
    CalendarInput: ()=>css`
		--input-height: 52px;
		background: ${({ theme  })=>theme.colors.white.base};
		color: ${({ theme  })=>theme.colors.grays.darker};
		${FontMixin({
            weight: 'regular',
            height: 'base'
        })}

		&:disabled {
			color: ${({ theme  })=>theme.colors.grays.base};
		}
	`
};
export default veciCalendarInputStyles;

//# sourceMappingURL=veci.js.map